import { Box, Button, Grid, Typography } from "@mui/material";
import { useBookingContext } from "../context/BookingContext";
import Modal from "react-responsive-modal";
import ZoneOutsideIsland from "./ZoneOutsideIsland";
import moment from "moment";
import { useTranslation } from "react-i18next";

function OutIslandUsage() {
  const { dateUsage, openZoneOutsideIsland, setOpenZoneOutsideIsland } = useBookingContext();
  const datas = dateUsage?.outOfIsland || [];
  const { t } = useTranslation();

  return (
    <>
      <Grid
        container
        spacing={3}
        padding={"3rem"}
        sx={{
          borderBottom: "1px solid rgba(119, 119, 119, 0.6235294118)",
        }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <Container
            onClick={() => {
              setOpenZoneOutsideIsland(true);
            }}
            btnTitle={t("add_outside_island")}
            title={t("outside_island_usage")}
          >
            <div style={{ color: "#706f7b" }}>{t("for_self_drive")}</div>
            {datas?.length ? (
              <Box sx={{ color: "green" }}>
                <span>{datas?.map((v) => moment(v).format("DD MMM"))?.join(",")}</span>
              </Box>
            ) : null}
          </Container>
        </Grid>
      </Grid>
      {openZoneOutsideIsland && (
        <Modal
          open={openZoneOutsideIsland}
          onClose={() => {}}
          showCloseIcon={false}
          styles={{
            root: { zIndex: 9999999991 },
            modal: {
              minWidth: 300,
            },
          }}
        >
          <ZoneOutsideIsland />
        </Modal>
      )}
    </>
  );
}

const Container = ({ title, children, btnTitle, onClick, dates }) => {
  return (
    <Box>
      <Typography fontSize={13} fontWeight="600">
        {title}
      </Typography>
      <Grid
        container
        sx={{
          alignItems: "end",
        }}
      >
        <Grid item xs={12} sm={6}>
          {children}
          {dates?.length ? <div>Dates : {dates.join(",")}</div> : null}
        </Grid>
        <Grid item xs={12} sm={6} sx={{ display: "flex", justifyContent: "flex-end" }}>
          {btnTitle ? (
            <Button
              variant="contained"
              onClick={onClick}
              disableElevation
              sx={{
                bgcolor: "#f5272b",
                borderRadius: "2px",
                fontWeight: "700",
                "&:hover": {
                  backgroundColor: "#f5272b",
                },
              }}
            >
              {btnTitle}
            </Button>
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};

export default OutIslandUsage;
